import { ReactNode, useEffect, useState } from 'react';

import { useRouter } from 'next/router';

import useAuthenticate from '@/hooks/useAuthenticate';
import { useTheme } from '@/hooks/useTheme';
import { cn } from '@/utils/helper';

import Navbar from '../Navbar';

type Prop = {
  children: ReactNode;
  steps?: boolean;
};

const LoginLayout = ({ children, steps }: Prop) => {
  const [isAuthLocal, setISauthLocal] = useState<boolean | null>(null);
  const router = useRouter();
  const { isAuth } = useAuthenticate();
  const { mode } = useTheme();

  useEffect(() => {
    if (isAuth !== null) {
      setISauthLocal(isAuth);
    }
  }, [isAuth, steps]);

  if (isAuthLocal === null) {
    return null;
  }

  if (isAuth && !steps) {
    router.push('/portfolio');
    return null;
  }

  return (
    <div className={cn('items-center w-full min-h-screen bg-white dark:bg-jet-black-50 flex flex-col justify-center overflow-x-hidden', mode)}>
      <Navbar otherLinksHide={true} />
      <div className='flex flex-col justify-center items-center max-w-[1300px] w-full h-full my-20 sm:my-0'>
        <div className='sm:!w-max px-4 sm:px-0 mt-10 min-w-[300px] min-[350px]:min-w-[350px] max-w-[468px] w-full relative z-[22]'>{children}</div>
      </div>
    </div>
  );
};
export { LoginLayout };
